module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('h3', [_vm._v("Sanction Outcome: " + _vm._s(_vm.displayLodgementNumber))])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-md-3"
  }, [_c('CommsLogs', {
    attrs: {
      "comms_url": _vm.comms_url,
      "logs_url": _vm.logs_url,
      "comms_add_url": _vm.comms_add_url,
      "disable_add_entry": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n                            Workflow\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Status")]), _c('br'), _vm._v("\n                                    " + _vm._s(_vm.statusDisplay)), _c('br')])]), _vm._v(" "), _c('Assignment', {
    key: _vm.assignmentKey,
    attrs: {
      "user_is_assignee": _vm.sanction_outcome.user_is_assignee,
      "allowed_group_ids": _vm.sanction_outcome.allowed_groups,
      "user_in_group": _vm.sanction_outcome.user_in_group,
      "assigned_to_id": _vm.sanction_outcome.assigned_to_id,
      "assign_url": _vm.assign_url
    },
    on: {
      "update-assigned-to-id": _vm.updateAssignedToId
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n                            Action\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [(_vm.visibilityExtendDueDateButton) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.extendDueDate('')
      }
    }
  }, [_vm._v("\n                                        Extend Due Date\n                                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.visibilityEscalateForWithdrawalButton) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('escalate_for_withdrawal')
      }
    }
  }, [_vm._v("\n                                        Escalate for Withdrawal\n                                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.visibilitySendParkingInfringementButton) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.sendParkingInfringement()
      }
    }
  }, [_vm._v("\n                                        Endorse Parking Infringement\n                                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.visibilityRecordFerCaseNumberButton) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.recordFerCaseNumber('')
      }
    }
  }, [_vm._v("\n                                        Record FER Case Number\n                                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.visibilityReturnToInfringementNoticeCoordinatorButton) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('return_to_infringement_notice_coordinator')
      }
    }
  }, [_vm._v("\n                                        Return to"), _c('br'), _vm._v("Infringement Notice Coordinator\n                                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.visibilityWithdrawByBranchManagerButton) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('withdraw_by_branch_manager')
      }
    }
  }, [_vm._v("\n                                        Withdraw\n                                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.visibilityWithdrawButtonForManager) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('withdraw_by_manager')
      }
    }
  }, [_vm._v("\n                                        Withdraw\n                                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.visibilityEndorseButton) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('endorse')
      }
    }
  }, [_vm._v("\n                                        Endorse\n                                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.visibilityDeclineButton) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('decline')
      }
    }
  }, [_vm._v("\n                                        Decline\n                                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.visibilityReturnToOfficerButton) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('return_to_officer')
      }
    }
  }, [_vm._v("\n                                        Return to Officer\n                                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.visibilitySendToManagerButton) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('send_to_manager')
      }
    }
  }, [_vm._v("\n                                        Send to Manager\n                                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.visibilityMarkDocumentPostedButton) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('mark_document_posted')
      }
    }
  }, [_vm._v("\n                                        Mark Document Posted\n                                    ")])])]) : _vm._e()])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    attrs: {
      "id": "main-column"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('ul', {
    staticClass: "nav nav-pills aho2"
  }, [_c('li', {
    staticClass: "nav-item active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.soTab
    }
  }, [_vm._v(_vm._s(_vm.typeDisplay))])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayRemediationActions),
      expression: "displayRemediationActions"
    }],
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.raTab
    }
  }, [_vm._v("Remediation Actions")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.deTab
    }
  }, [_vm._v("Details")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.reTab
    }
  }, [_vm._v("Related Items")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": _vm.soTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": _vm.typeDisplay,
      "Index": "1"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Identifier")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.identifier),
      expression: "sanction_outcome.identifier"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.sanction_outcome.identifier)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sanction_outcome, "identifier", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Offence")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displayOffence),
      expression: "displayOffence"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": "true"
    },
    domProps: {
      "value": (_vm.displayOffence)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.displayOffence = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Offender")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.sanction_outcome && _vm.sanction_outcome.offence && _vm.sanction_outcome.offence.offenders) ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.offender),
      expression: "sanction_outcome.offender"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.sanction_outcome, "offender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.sanction_outcome.offence.offenders), function(offender) {
    return _c('option', {
      key: offender.id,
      domProps: {
        "value": offender
      }
    }, [(offender.person) ? _c('span', [_vm._v("\n                                                            " + _vm._s(offender.person.first_name + ' ' + offender.person.last_name + ', DOB:' + offender.person.dob) + "\n                                                        ")]) : (offender.organisation) ? _c('span', [_vm._v("\n                                                            " + _vm._s(offender.organisation.name + ', ABN: ' + offender.organisation.abn) + "\n                                                        ")]) : _vm._e()])
  })], 2)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Vehicle Registration Number")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.registration_number),
      expression: "sanction_outcome.registration_number"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.sanction_outcome.registration_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sanction_outcome, "registration_number", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('label', [_vm._v("Alleged committed offence")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('datatable', {
    ref: "alleged_committed_offence_table",
    attrs: {
      "id": "alleged-committed-offence-table",
      "dtOptions": _vm.dtOptionsAllegedOffence,
      "dtHeaders": _vm.dtHeadersAllegedOffence
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Issued on paper?")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.issued_on_paper),
      expression: "sanction_outcome.issued_on_paper"
    }],
    staticClass: "col-sm-1",
    attrs: {
      "disabled": _vm.readonlyForm,
      "id": "issued_on_paper_yes",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.sanction_outcome.issued_on_paper, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.sanction_outcome, "issued_on_paper", true)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 radio-button-label",
    attrs: {
      "for": "issued_on_paper_yes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.issued_on_paper),
      expression: "sanction_outcome.issued_on_paper"
    }],
    staticClass: "col-sm-1",
    attrs: {
      "disabled": _vm.readonlyForm,
      "id": "issued_on_paper_no",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.sanction_outcome.issued_on_paper, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.sanction_outcome, "issued_on_paper", false)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 radio-button-label",
    attrs: {
      "for": "issued_on_paper_no"
    }
  }, [_vm._v("No")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Paper ID")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.paper_id),
      expression: "sanction_outcome.paper_id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": _vm.readonlyForm,
      "name": "paper_id",
      "placeholder": "",
      "disabled": !_vm.sanction_outcome.issued_on_paper
    },
    domProps: {
      "value": (_vm.sanction_outcome.paper_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sanction_outcome, "paper_id", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Paper notice")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "paper_id_notice"
    }
  }, [(_vm.sanction_outcome.issued_on_paper) ? _c('div', {
    staticClass: "col-sm-7"
  }, [_c('filefield', {
    ref: "sanction_outcome_file",
    attrs: {
      "name": "sanction-outcome-file",
      "documentActionUrl": _vm.sanction_outcome.sanctionOutcomeDocumentUrl,
      "isRepeatable": true,
      "readonly": _vm.readonlyForm
    },
    on: {
      "update-parent": _vm.sanctionOutcomeDocumentUploaded
    }
  })], 1) : _vm._e()])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.raTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Remediation Actions",
      "Index": "2"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row col-sm-12"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Remediation Actions")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('datatable', {
    ref: "tbl_remediation_actions",
    attrs: {
      "id": "tbl_remediation_actions",
      "dtOptions": _vm.dtOptionsRemediationActions,
      "dtHeaders": _vm.dtHeadersRemediationActions
    }
  })], 1)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.deTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Details",
      "Index": "3"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Description")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.description),
      expression: "sanction_outcome.description"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm,
      "placeholder": "add description",
      "id": "sanction-outcome-description"
    },
    domProps: {
      "value": (_vm.sanction_outcome.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sanction_outcome, "description", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Date of Issue")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    ref: "dateOfIssuePicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.date_of_issue),
      expression: "sanction_outcome.date_of_issue"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY",
      "disabled": !_vm.sanction_outcome.issued_on_paper || _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.sanction_outcome.date_of_issue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sanction_outcome, "date_of_issue", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Time of Issue")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    ref: "timeOfIssuePicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.time_of_issue),
      expression: "sanction_outcome.time_of_issue"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "HH:MM",
      "disabled": !_vm.sanction_outcome.issued_on_paper || _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.sanction_outcome.time_of_issue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sanction_outcome, "time_of_issue", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])])])]), _vm._v(" "), (_vm.visibilityParkingInfringementSection) ? _c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Further Offender Details",
      "Index": "4"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Registration Holder:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('RegistrationHolder', {
    key: _vm.registrationHolderBindId,
    ref: "search_registration_holder",
    attrs: {
      "showClearPerson": true,
      "excludeStaff": true,
      "personOnly": true,
      "displayTitle": false,
      "isEditable": _vm.canUserEditParkingDetails,
      "parentEntity": _vm.registrationHolder,
      "classNames": "form-control",
      "showCreateUpdate": "",
      "domIdHelper": "registration_holder"
    },
    on: {
      "entity-selected": _vm.registrationHolderSelected,
      "clear-person": _vm.clearRegistrationHolder
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Driver:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('Driver', {
    key: _vm.updateDriverBindId,
    ref: "search_driver",
    attrs: {
      "showClearPerson": true,
      "excludeStaff": true,
      "personOnly": true,
      "displayTitle": false,
      "isEditable": _vm.canUserEditParkingDetails,
      "parentEntity": _vm.driver,
      "classNames": "form-control",
      "showCreateUpdate": "",
      "domIdHelper": "driver"
    },
    on: {
      "entity-selected": _vm.driverSelected,
      "clear-person": _vm.clearDriver
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.sanction_outcome.due_dates && _vm.sanction_outcome.due_dates.length > 0) ? _c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Due Date",
      "Index": "5"
    }
  }, _vm._l((_vm.sanction_outcome.due_dates), function(item) {
    return _c('div', [_c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-3"
    }, [_c('label', [_vm._v("Payment due date:")])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('span', [_vm._v(_vm._s(_vm.formatDate(item.due_date_applied)))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', [_vm._v("Reason:")])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4"
    }, [_vm._v("\n                                                " + _vm._s(item.reason_for_extension) + "\n                                            ")])])])])
  }), 0) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.reTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Related Items",
      "Index": "6"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('RelatedItems', {
    key: _vm.relatedItemsBindId,
    attrs: {
      "parent_update_related_items": _vm.setRelatedItems,
      "readonlyForm": _vm.readonlyForm
    }
  })], 1)])])])], 1)])])])])]), _vm._v(" "), (_vm.visibilitySaveButton) ? _c('div', {
    staticClass: "navbar navbar-fixed-bottom",
    staticStyle: {
      "background-color": "#f5f5f5"
    }
  }, [_c('div', {
    staticClass: "navbar-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Save and Exit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveExit($event)
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Save and Continue"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.workflow_type) ? _c('div', [_c('SanctionOutcomeWorkflow', {
    key: _vm.workflowBindId,
    ref: "add_workflow",
    attrs: {
      "workflow_type": _vm.workflow_type
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.extendPaymentDueDateInitialized) ? _c('div', [_c('ExtendPaymentDueDate', {
    key: _vm.extendDueDateBindId,
    ref: "extend_payment_due_date",
    attrs: {
      "due_date_1st": _vm.last_due_date_1st,
      "due_date_2nd": _vm.last_due_date_2nd,
      "due_date_max": _vm.sanction_outcome.due_date_extended_max
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.recordFerCaseNumberInitialized) ? _c('div', [_c('RecordFerCaseNumber', {
    key: _vm.recordFerCaseNumberBindId,
    ref: "record_fer_case_number"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.sendParkingInfringementInitialized) ? _c('div', [_c('SendParkingInfringement', {
    key: _vm.sendParkingInfringementBindId,
    ref: "send_parking_infringement"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.acceptRemediationActionInitialized) ? _c('div', [_c('AcceptRemediationAction', {
    key: _vm.acceptRemediationActionBindId,
    ref: "accept_remediation_action",
    attrs: {
      "remediation_action_id": _vm.remediation_action_id
    },
    on: {
      "remediation_action_accepted": _vm.onRemediationActionUpdated
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.requestAmendmentRemediationAction) ? _c('div', [_c('RequestAmendmentRemediationAction', {
    key: _vm.requestAmendmentRemediationActionBindId,
    ref: "request_amendment_remediation_action",
    attrs: {
      "remediation_action_id": _vm.remediation_action_id
    },
    on: {
      "remediation_action_updated": _vm.onRemediationActionUpdated
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cb9792b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/internal/sanction_outcome/sanction_outcome.vue
// module id = 1006
// module chunks = 0